import * as React from 'react';

import styles from './radio-group-simple.module.css';

type Option = {
    label: string | React.ReactElement<any>;
    id: string;
};

type Props = {
    name: string;
    isWide?: boolean;
    options: Option[];
    selectedOption?: string | Option;
    disabledOptions?: string | Option;
    onChange: (arg1: any, arg2: Event) => any;
};

export class RadioGroupSimple extends React.Component<Props> {
    render() {
        const {disabledOptions, selectedOption} = this.props;

        return (
            <div className={styles.container}>
                {this.props.options.map((opt) => {
                    const other = {
                        // @ts-expect-error
                        onChange: (e) => {
                            this.props.onChange(opt.id, e);
                        },
                        checked: undefined,
                        disabled: false,
                    } as const;

                    if (typeof selectedOption === 'string') {
                        // @ts-expect-error
                        other.checked = selectedOption === opt.id;
                    } else if (typeof selectedOption === 'object') {
                        // @ts-expect-error
                        other.checked = selectedOption.id === opt.id;
                    }

                    if (Array.isArray(disabledOptions) && disabledOptions.length) {
                        // Allow array of strings or objects
                        // @ts-expect-error
                        other.disabled =
                            disabledOptions.includes(opt.id) ||
                            disabledOptions.map((x) => x.id).includes(opt.id);
                    }

                    const inputId = `${this.props.name}-${opt.id}`;

                    return [
                        <input
                            key={opt.id}
                            id={inputId}
                            name={this.props.name}
                            type='radio'
                            {...other}
                        />,
                        <label
                            key={`${opt.id}-label`}
                            htmlFor={inputId}
                            className={
                                this.props.isWide ? styles.label : styles['label--icon-only']
                            }
                        >
                            {opt.label}
                        </label>,
                    ];
                })}
            </div>
        );
    }
}
